// extracted by mini-css-extract-plugin
export var legendIndicator = "_ay-1";
export var legendRight = "_ay-0";